module.exports = __webpack_public_path__ + "static/yam-1-908c3a85bbde011379382f82e36e95dd.jpg";